import React from 'react';
import { MicIcon } from '../../MessageInput/icons';
export const StartRecordingAudioButton = (props) => (React.createElement("button", { "aria-label": 'Start recording audio', className: 'str-chat__start-recording-audio-button', "data-testid": 'start-recording-audio-button', ...props },
    React.createElement(MicIcon, null)));
